import wrappedFetch from './base';

const fetchStaticIpPlans = () => {
  return wrappedFetch('/static_ip_plans.json')
    .then((response) => response.json());
};

export default fetchStaticIpPlans;
